(function () {
    'use strict';

    angular.module('soopkitchenApp').controller('InsertPlanController', InsertPlanController);

    InsertPlanController.$inject = ['$controller', '$sce', '$uibModalInstance', 'AlertService', 'parameters', 'SoopkitchenUtils', 'Planning', 'PlanTypes', '$http'];

    function InsertPlanController($controller, $sce, $uibModalInstance, AlertService, parameters, SoopkitchenUtils, Planning, PlanTypes, $http) {

        var vm = this;
        var title = 'Insert a Child or <b>Operational Plan</b> into Plan <span class="label label-info">' + parameters.label + '</span>, Version <span\n' +
            'class="label label-info">' + parameters.internalVersion + '</span>';
        angular.extend(this, $controller('SoopkitchenDialogController',
            {"title": title, $sce: $sce, $uibModalInstance: $uibModalInstance}));
        /** ** Constants *** */
        var IN_SITU_INSTRUMENTS = ['EPD', 'MAG', 'RPW', 'SWA'];
        var REMOTE_SENSING_INSTRUMENTS = ['EUI', 'Metis', 'PHI', 'SPICE', 'STIX', 'SoloHI'];
        /**** Properties ****/
        vm.checkedAll = true;
        vm.planType = parameters.planType;
        vm.operationalPlanToImport = [];
        vm.childPlanToImport = [];
        vm.nonSelectedPlan = {label: '', internalVersion: 0};
        vm.operationalPlanToImport.push(vm.nonSelectedPlan);
        vm.childPlanToImport.push(vm.nonSelectedPlan);
        vm.selectedOperationalPlan = vm.nonSelectedPlan;
        vm.selectedChildPlan = vm.nonSelectedPlan;
        vm.selected = vm.nonSelectedPlan;
        vm.toTime = null;
        vm.fromTime = null;
        vm.selectedInternalVersion = 0;
        vm.maxInternalVersion = 0;
        vm.saveDisabled = true;
        vm.rsInstruments = REMOTE_SENSING_INSTRUMENTS;
        vm.isInstruments = IN_SITU_INSTRUMENTS;

        vm.calculateSaveDisabled = calculateSaveDisabled;
        vm.toggleCheckAll = toggleCheckAll;
        vm.instrumentsSelected = instrumentsSelected;
        vm.groupChange = groupChange;

        vm.checkedValue ={};
        vm.groups = createGroups();
        vm.onSelectChildPlan = function () {
            vm.selectedInternalVersion = 0;
            vm.selectedOperationalPlan = vm.nonSelectedPlan;
            vm.maxInternalVersion = vm.selectedChildPlan.internalVersion;
            vm.selected = vm.selectedChildPlan;
            calculateSaveDisabled();
        };

        vm.onSelectOperationalPlan = function () {
            vm.selectedInternalVersion = 0;
            vm.selectedChildPlan = vm.nonSelectedPlan;
            vm.maxInternalVersion = vm.selectedOperationalPlan.internalVersion;
            vm.selected = vm.selectedOperationalPlan;
            calculateSaveDisabled();
        };

        /**** Methods ****/
        //Override Methods from SoopkitchenDialogController
        vm.save = importPlan;
        vm.isValidDate = isValidDate;

        Planning.getAllLatestPlans(
            {
                planType: PlanTypes['master']
            },
            function onSuccess(data, headers) {
                for (var i = 0; i < data.length; i++) {
                    if (parameters.obsDefLabel === data[i].observationDefinitionsLabel && parameters.label !== data[i].label) {
                        vm.operationalPlanToImport.push({label: data[i].label, internalVersion: data[i].internalVersion});
                    }
                }
            },
            function errorCallback(error) {
            }
        );

        Planning.getAllLatestPlans(
            {
                planType: PlanTypes['child']
            },
            function onSuccess(data, headers) {
                for (var i = 0; i < data.length; i++) {
                    if (parameters.obsDefLabel === data[i].observationDefinitionsLabel && parameters.label !== data[i].label) {
                        vm.childPlanToImport.push({label: data[i].label, internalVersion: data[i].internalVersion});
                    }
                }
            },
            function errorCallback(error) {
            }
        );

        function isValidDate(date) {
            var isValid = true;
            if (date !== null && date !== '') {
                isValid = SoopkitchenUtils.isValidDate(date);
            }
            return isValid;
        }

        function calculateSaveDisabled() {
            vm.saveDisabled = vm.selectedOperationalPlan === vm.nonSelectedPlan && vm.selectedChildPlan === vm.nonSelectedPlan;
        }

        function successImportPlan(response) {
            SoopkitchenUtils.processResponse(
                response,
                "Plan has been imported",
                vm.selected.label + " has been imported into " + parameters.label,
                function () {
                    SoopkitchenUtils.updatePlanFromDialog(response.data);
                    $uibModalInstance.dismiss('cancel');
                }
            );
        }

        function failureImportPlan(response) {
            SoopkitchenUtils.prettyError(response);
        }



        function instrumentsSelected() {
            var listInstruments = [];
            for (var group in vm.groups) {
                if (vm.checkedValue[vm.groups[group]] === true){
                    listInstruments.push(vm.groups[group]);
                }
            }
            return listInstruments.join(',');
        }

        function importPlan() {
            if (vm.fromTime !== null && vm.fromTime.trim() === '') {
                vm.fromTime = null;
            }
            if (vm.toTime !== null && vm.toTime.trim() === '') {
                vm.toTime = null;
            }

            $http({
                method: 'PUT',
                url: 'api/' + vm.planType + '/import-plan',
                params: {
                    'planLabel': parameters.label,
                    'importLabel': vm.selected.label,
                    'from': vm.fromTime,
                    'to': vm.toTime,
                    'internalVersion': vm.selectedInternalVersion,
                    'instruments': vm.instrumentsSelected()
                }
            }).then(successImportPlan, failureImportPlan);
        }
        function toggleCheckAll() {
            vm.checkedAll = vm.checkedAll === false;
            for (var group in vm.groups) {
                 vm.checkedValue[vm.groups[group]] = vm.checkedAll;
            }
        }
        function createGroups() {
            var instruments = Array.from(REMOTE_SENSING_INSTRUMENTS.concat(IN_SITU_INSTRUMENTS));
            var groupsList = [];
            for (var i = 0; i < instruments.length; i++) {
                var group = instruments[i];
                if (vm.checkedValue[group] == null) {
                    vm.checkedValue[group] = true;
                }
            }
            return instruments;
        }
        function groupChange(group) {
            vm.checkedValue[group] = (false === vm.checkedValue[group]);
        }

    }
})();
